import { render, staticRenderFns } from "./cate.vue?vue&type=template&id=6f4f8cb4"
import script from "./cate.vue?vue&type=script&lang=js"
export * from "./cate.vue?vue&type=script&lang=js"
import style0 from "./cate.vue?vue&type=style&index=0&id=6f4f8cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports